export default "__VITE_ASSET__d7b14e17__"